import React from "react";
import { Route, Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
    return localStorage.getItem("token-api") ? (
         children
    ) : (
         <Navigate to={{ pathname: "/login" }} />
    )
    

    };

export default PrivateRoute;